import * as TypeGraphQL from "type-graphql";
export var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity["LOW"] = "LOW";
    AlertSeverity["MEDIUM"] = "MEDIUM";
    AlertSeverity["HIGH"] = "HIGH";
    AlertSeverity["CRITICAL"] = "CRITICAL";
})(AlertSeverity || (AlertSeverity = {}));
TypeGraphQL.registerEnumType(AlertSeverity, {
    name: "AlertSeverity",
    description: undefined,
});
//# sourceMappingURL=AlertSeverity.js.map